<div class="netsuite-ledger-page">

    <div class="page-header">
        <h4>Security Ledger</h4>
    </div>

    <div *ngIf="loading"
         class="loading-message"
         role="status"
         aria-live="polite">

        <div class="spinner-border" role="presentation"></div>
        <p>Loading NetSuite Ledger...</p>
    </div>

    <div *ngIf="errorMessage"
         class="alert alert-danger"
         role="alert">

        <p>{{ errorMessage }}</p>

        <button type="button"
                class="btn btn-outline-danger"
                (click)="retry()">
            Retry
        </button>
    </div>


    <div class="tableau-container"
         [hidden]="loading || !!errorMessage">

        <tableau-viz *ngIf="token && vizUrl && !loading && !errorMessage"
                     [src]="vizUrl"
                     [token]="token"
                     toolbar="top"
                     width="1200px"
                     height="800px"
                     (vizloaderror)="onVizLoadError($event)">
        </tableau-viz>

    </div>

</div>